const TONES = {
  success: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  warning: "bg-amber-50 text-amber-700 ring-amber-200",
  info: "bg-sky-50 text-sky-700 ring-sky-200",
  danger: "bg-rose-50 text-rose-700 ring-rose-200",
  muted: "bg-neutral-100 text-neutral-600 ring-neutral-200",
};

export const StatusChip = ({ status, testId }) => {
  if (!status?.label) return null;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[11px] font-semibold ring-1 ring-inset ${TONES[status.tone] || TONES.muted}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status.label}
    </span>
  );
};
